'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$Cta(label, to) {
  this.fA = null;
  this.fB = null;
  this.fA = label;
  this.fB = to;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$Cta as $c_Lio_intela_sites_digitalinternship_data_Segments$Cta };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$Cta.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$Cta;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$Cta() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$Cta as $h_Lio_intela_sites_digitalinternship_data_Segments$Cta };
$h_Lio_intela_sites_digitalinternship_data_Segments$Cta.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 911485666, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$Cta)) {
    if ((this.fA === x$0.fA)) {
      var x = this.fB;
      var x$2 = x$0.fB;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Cta";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.fA;
  }
  if ((n === 1)) {
    return this.fB;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Cta(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bw)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Cta as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Cta };
var $d_Lio_intela_sites_digitalinternship_data_Segments$Cta = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$Cta, "io.intela.sites.digitalinternship.data.Segments$Cta", ({
  bw: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$Cta as $d_Lio_intela_sites_digitalinternship_data_Segments$Cta };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Cta.js.map
